(function () {
    window.addEventListener('DOMContentLoaded', function (event) {

        {
            const selector_free_space='#free-space';
            let ary_selector_animation_class=[
                `${selector_free_space} .layer1`,
                `${selector_free_space} .layer2`,
                `${selector_free_space} .layer3`,
                `${selector_free_space} .layer4`,
                `${selector_free_space} .layer5`,
            ];

            let animation_index=0;

            for(selector_animation_class of ary_selector_animation_class){
                let DOM_temp = document.querySelector(selector_animation_class);
                if(DOM_temp === null){
                    console.log(`freespace-slideanimation: [warning] DOM query failed: ${selector_animation_class}`);
                    continue;
                }

                DOM_temp.addEventListener('animationend',(e)=>{

                    let selector_current;
                    let selector_next;
                    
                    selector_current = ary_selector_animation_class[animation_index];
                    animation_index=(animation_index+1)%(ary_selector_animation_class.length);
                    selector_next = ary_selector_animation_class[animation_index];
                    
                    DOM_current = document.querySelector(selector_current);
                    DOM_next = document.querySelector(selector_next);

                    DOM_current.classList.remove('animate');
                    DOM_next.classList.add('animate');
                });

            }
            //document.querySelector('#free-space .layer1').classList.add('animate');
        }
    });
})();
